import React, {useState} from "react";
import {Avatar} from "primereact/avatar";
import {Dialog} from "primereact/dialog";
import {Link} from "react-router-dom";
import {Button} from "primereact/button";

export default function CoWorkerWidget(props) {
	const [visible, setVisible] = useState(false);
	console.log(props);
	const busyPercentage = props?.data?.coworkers?.reduce((acc, coworker) => {
		return acc + coworker?.busy_percentage;
	}, 0);
	return (
		<>
			<Button
				text
				severity="secondary"
				onClick={() => {
					setVisible(true);
					localStorage.setItem("item", props?.data.id);
				}}
				className="row text-start">
				<div className=" text-primary p-0">{props?.data?.full_name_am}</div>
				<hr className="mt-2 my-1" />
				<div className="col-lg-9 col-12 p-0">
					<div className="d-grid" style={{minHeight: "60px"}}>
						{props?.data?.coworkers?.slice(0, 5).map(coworker => (
							<span className="text-truncate small">{coworker?.project.full_name_am} </span>
						))}
					</div>
				</div>
				<div className="col-lg-3 col-12">
					<div
						className="d-flex justify-content-between align-items-center"
						style={{minHeight: "60px", minWidth: "180px"}}>
						<div className="progress w-100 b-radius border-0" style={{height: "8px"}}>
							<div
								className={
									busyPercentage <= 15
										? `progress-bar bg-secondary`
										: busyPercentage <= 30
										? `progress-bar bg-danger`
										: busyPercentage <= 55
										? `progress-bar bg-info`
										: busyPercentage <= 75
										? `progress-bar bg-warning`
										: busyPercentage <= 100
										? `progress-bar bg-success`
										: "progress-bar bg-danger"
								}
								role="progressbar"
								style={{width: busyPercentage + "%"}}
								aria-valuenow={busyPercentage}
								aria-valuemin="0"
								aria-valuemax="100"></div>
						</div>
						<span className="fw-semibold ms-4">{busyPercentage + "%"}</span>
					</div>
				</div>
			</Button>

			<Dialog
				header={props?.data?.full_name_am || props?.data?.company_am}
				visible={visible}
				onHide={() => setVisible(false)}
				className="col-lg-6 col-12 p-0 border-bottom">
				<div className="row p-0 m-0 ">
					<div className="col-12">
						<div className="d-flex">
							<div className="col">
								<div className="fs-4 fw-bolder text-primary">{props?.data?.coworkers?.length}</div>
								<div className="text-muted">Ընթացիկ նախագծեր</div>
							</div>
							<div className="col">
								<div className="fs-4  fw-bolder text-primary">{props?.data?.coworkers?.length}</div>
								<div className="text-muted">Ավարտած նախագծեր</div>
							</div>
						</div>
					</div>
					<div className="row">
						<span className="fw-bolder border-bottom pb-2 w-100 col-12">Նախագծեր:</span>
						<div className="d-grid">
							{props?.data?.coworkers?.map(coworker => (
								<div className="row">
									<div className="col-md-10">
										<div className="my-3">
											<div className="d-flex justify-content-between align-items-center mb-2">
												<span className="d-grid">
													<span className="fw-bold">{coworker?.project?.name} </span>
													<span className="small text-truncate">
														{coworker?.project?.full_name_am}
													</span>
												</span>
												<span className="fw-bold ps-5 fs-5">{coworker?.busy_percentage + "%"}</span>
											</div>
											<div className="progress w-100 b-radius border-0" style={{height: "5px"}}>
												<div
													className={
														coworker?.busy_percentage <= 15
															? `progress-bar bg-secondary`
															: coworker?.busy_percentage <= 30
															? `progress-bar bg-danger`
															: coworker?.busy_percentage <= 55
															? `progress-bar bg-info`
															: coworker?.busy_percentage <= 75
															? `progress-bar bg-warning`
															: coworker?.busy_percentage <= 100
															? `progress-bar bg-success`
															: "null"
													}
													role="progressbar"
													style={{width: coworker?.busy_percentage + "%"}}
													aria-valuenow={coworker?.busy_percentage}
													aria-valuemin="0"
													aria-valuemax="100"></div>
											</div>
										</div>
									</div>
									<div className="col-md-2 py-3">
										<Button
											icon="pi pi-trash"
											text
											rounded
											severity="danger"
											onClick={e => {
												props?.confirmDelete();
												setVisible(false);
											}}
										/>
										<Button
											icon="pi pi-pencil"
											text
											rounded
											severity="success"
											onClick={e => (
												props?.setEditDialog(true), props.setUserInfo(props.data), setVisible(false)
											)}
										/>
									</div>
								</div>
							))}
						</div>
					</div>
					<div className="col-12 text-center my-3">
						<Link to={"/co_workers/" + props?.data.id} className="btn ">
							Մանրամասները անձնական էջում
						</Link>
					</div>
				</div>
			</Dialog>
		</>
	);
}
